// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/work_compass_steps.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/planners/v1/resources/work_compass_steps.proto.
 */
export const file_studyo_today_planners_v1_resources_work_compass_steps = /*@__PURE__*/
  fileDesc("CjtzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3dvcmtfY29tcGFzc19zdGVwcy5wcm90bxIic3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcyJRChBXb3JrQ29tcGFzc1N0ZXBzEhcKD3N1Z2dlc3RlZF9zdGVwcxgBIAMoCRIOCgZyZWFzb24YAiABKAkSFAoMaXNfYW5hbHl6aW5nGAMgASgIQiqqAidTdHVkeW8uVG9kYXkuUGxhbm5lcnMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw");

/**
 * Describes the message studyo.today.planners.v1.resources.WorkCompassSteps.
 * Use `create(WorkCompassStepsSchema)` to create a new message.
 */
export const WorkCompassStepsSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_work_compass_steps, 0);

